'use strict';

import { NumericFilter } from '../module/dashboard/model/numericFilter';
import { Operator } from '../module/operator/enum/operator';

export default [function () {

    return {
        getNumericFilter,
        defaultEmptySelectorElement,
    };

    function defaultEmptySelectorElement(elementName = 'Все') {
        return {
            id: null,
            name: elementName,
        };
    }

    function getNumericFilter(filterParams) {
        if (filterParams.operator === Operator.BETWEEN
            && (!angular.isNumber(filterParams.value) || !angular.isNumber(filterParams.endValue))) {
            return null;
        }

        if (!angular.isNumber(filterParams.value)) return null;

        return new NumericFilter(filterParams);
    }
}];
